import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

export const userGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const token: any = localStorage.getItem('ShuwierToken');
  // const token: any = authService.getAccessToken();
  // const type = authService?.currentUserValue?.user?.type; // 'freelancer' | 'client'
  console.log('token token token', token);
  if (!token) {
    // لو مفيش توكن → يمنع الدخول
    router.navigate(['/auth/login']);
    return false;
  }

  // لو فيه توكن → السماح حسب النوع

  // if (type === 'freelancer') {
  //   if (state.url.startsWith('/freelancer')) {
  //     return true; // مسموح
  //   } else {
  //     router.navigate(['/freelancer/projects']); // أي مسار مش بتاعه → redirect
  //     return false;
  //   }
  // } else if (type === 'client') {
  //   if (state.url.startsWith('/user')) {
  //     return true; // مسموح
  //   } else {
  //     router.navigate(['/user/projects']); // أي مسار مش بتاعه → redirect
  //     return false;
  //   }
  // } else {
  //   // نوع غير معروف → ارسله للlogin
  //   router.navigate(['/auth/login']);
  //   return false;
  // }
  return true;
};
